// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".audit-trail-action-panel{display:flex;justify-content:flex-end;padding:6px}.audit-trail-action-panel>div:first-child,.audit-trail-action-panel button{border-radius:4px;padding:4px;line-height:0;border:none}.audit-trail-action-panel>div:first-child:hover,.audit-trail-action-panel button:hover{cursor:pointer;background:#d3d3d3}", ""]);
// Exports
module.exports = exports;
